module.exports = __webpack_public_path__ + "img/toujours-jaune-winner.41b36755.jpg";